import { render, staticRenderFns } from "./EditorImage2.vue?vue&type=template&id=f20b5fb2&scoped=true&"
import script from "./EditorImage2.vue?vue&type=script&lang=js&"
export * from "./EditorImage2.vue?vue&type=script&lang=js&"
import style0 from "./EditorImage2.vue?vue&type=style&index=0&id=f20b5fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b5fb2",
  null
  
)

export default component.exports